import React, { useState, useEffect } from 'react';
import { getFormattedPriceObject } from '@/helpers/currencyHelpers';
import { useCurrencyConverter } from '@/hooks/currencyConverter.hook';
import { useFetchPostCommentById } from '@/services/postCommentsCopyService';
import { useFetchSpaceSubtypeRelationshipById } from '@/services/spacesSubtypeRelationshipService';

export const useProductDetails = (id, currencyData, isFromMexico) => {
  const [isLoading, setIsLoading] = useState(true);
  const [spaceDetailInfo, setSpaceDetailInfo] = useState([]);
  const { convert, convertBack } = useCurrencyConverter();

  const { data: commentsData, commentsError } = useFetchPostCommentById(id);
  const { data: spaceDetailData, spaceDetailError } = useFetchSpaceSubtypeRelationshipById(id);

  const formatSpacsData = (spaceData) => {
    const formattedPriceObject = getFormattedPriceObject(
      spaceData,
      currencyData?.currency,
      convert,
      convertBack,
    );
    const object = {
      ...spaceData,
      calculatedPrice: formattedPriceObject?.calculatedPrice,
      currency: formattedPriceObject?.currency,
      formattedPrice: formattedPriceObject?.formattedPrice,
    };
    console.log('! ', object);

    setSpaceDetailInfo(object);
  };

  useEffect(() => {
    if (!id) return;
    const commentsLoaded = commentsData || commentsError;
    const spaceLoaded = spaceDetailData || spaceDetailError;
    if (spaceLoaded) {
      setIsLoading(false);
      formatSpacsData(spaceDetailData[0]);
    }
    if (!commentsLoaded) {
      console.log('There are no comments');
    }
  }, [commentsData, commentsError, spaceDetailData, spaceDetailError, id, currencyData]);

  return {
    isLoading,
    commentsData,
    commentsError,
    spaceDetailInfo,
    spaceDetailError,
  };
};
